module.exports = __webpack_public_path__ + "static/media/camera-home.48640308.svg";